export default {
  main: {
  },
  content: {
    alignItems: 'stretch',
  },
}
